import {
  EDIT_EVALUATION_INFO,
  EDIT_EVALUATION_QUESTION,
  ADD_EVALUATION,
  ADD_EVALUATION_SUCCESS,
  ADD_EVALUATION_FAILED,
  EDIT_EVALUATION_AUTHOR,
  EDIT_EVALUATION_AUTHOR_SUCCESS,
  EDIT_EVALUATION_AUTHOR_FAILED,
  EDIT_PEER_RESPONSE,
  EDIT_PEER_RESPONSE_FAILED,
  EDIT_PEER_RESPONSE_SUCCESS,
  CHANGE_EVALUATION_STATE
} from "./constants";

import db from "../../firebaseAPI";

function updateEvaluationRequest(data) {
  return {
    type: EDIT_EVALUATION_INFO,
    payload: {
      data
    }
  };
}

export function updateEvaluation(data) {
  return dispatch => {
    dispatch(updateEvaluationRequest(data));
  };
}

// change state
function evaluationStateRequest(type) {
  return {
    type: CHANGE_EVALUATION_STATE,
    payload: {
      type
    }
  };
}

export function evaluationState(type) {
  return dispatch => {
    dispatch(evaluationStateRequest(type));
  };
}

// questions

function updateEvaluationQuestionRequest(id, value) {
  return {
    type: EDIT_EVALUATION_QUESTION,
    payload: {
      id,
      value
    }
  };
}

export function updateEvaluationQuestion(id, value, cb) {
  return dispatch => {
    const realValue = 0;

    dispatch(
      updateEvaluationQuestionRequest(id, value === 0.1 ? realValue : value)
    );
    if (value && cb) {
       cb()
    }
  };
}

// script transactional analysis

// complete evaluation

export function completeEvaluationRequest() {
  return {
    type: ADD_EVALUATION,
    payload: {}
  };
}

export function completeEvaluationSuccess(id) {
  return {
    type: ADD_EVALUATION_SUCCESS,
    payload: {
      id
    }
  };
}

export function completeEvaluationFailed(payload) {
  return {
    type: ADD_EVALUATION_FAILED,
    payload: {
      data: { ...payload }
    }
  };
}

export function addDriver(data, userInfo, user, language, type) {
  let parentId;
  return dispatch => {
    dispatch(completeEvaluationRequest());

    return db
      .collection("evaluations")
      .where("userId", "==", user.uid)
      .where("type", "==", "profile")
      .limit(1)
      .get()
      .then(evaluation => (parentId = evaluation.docs[0].id))
      .then(function() {
        return db.collection("drivers").add({
          answers: {
            ...data
          },
          createTime: window.firebase.firestore.FieldValue.serverTimestamp(),
          language: language,
          type: type,
          transactionalanalysisId: parentId,
          userId: user.uid
        });
      })
      .catch(function(error) {
        dispatch(completeEvaluationFailed(error));
      })
      .then(function(doc) {
        db.collection("users")
          .doc(user.uid)
          .update(
            type === "twelvesections"
              ? {
                  hasFilled12: true
                }
              : {
                  hasFilled24: true
                }
          );
        db.collection("evaluations")
          .doc(parentId)
          .update({ [`driver.${type}`]: doc.id });
        dispatch(completeEvaluationSuccess(doc.id));
      })

      .catch(function(error) {
        dispatch(completeEvaluationFailed(error));
      });
  };
}

export function completeEvaluation(data, userInfo, user, language, type) {
  return dispatch => {
    dispatch(completeEvaluationRequest());

    if (type === "profile") {
      db.collection("users")
        .doc(user.uid)
        .get()
        .then(userData => {
          db.collection("users")
            .doc(user.uid)
            .update({
              hasFilledTa: true
            });
        });
    }

    if (user && !user.experience) {
      db.collection("users")
        .doc(user.uid)
        .get()
        .then(userData => {
          db.collection("users")
            .doc(user.uid)
            .update({
              age: userInfo.age,
              education: userInfo.educationalLevel,
              experience: userInfo.leadershipExp,
              references: userInfo.numberOfReferences
            });
        })
        .catch(function(error) {
        });
    }

    return db
      .collection("evaluations")
      .add({
        answers: {
          ...data
        },
        author: {
          ...userInfo
        },
        userId: user && user.uid,
        createTime: window.firebase.firestore.FieldValue.serverTimestamp(),
        language: language,
        type: type
      })

      .then(function(doc) {
        dispatch(completeEvaluationSuccess(doc.id));
      })
      .catch(function(error) {
        dispatch(completeEvaluationFailed(error));
      });
  };
}

// update evaluation author

export function updateEvaluationAuthorRequest() {
  return {
    type: EDIT_EVALUATION_AUTHOR,
    payload: {}
  };
}

export function updateEvaluationAuthorSuccess() {
  return {
    type: EDIT_EVALUATION_AUTHOR_SUCCESS,
    payload: {}
  };
}

export function updateEvaluationAuthorFailed(payload) {
  return {
    type: EDIT_EVALUATION_AUTHOR_FAILED,
    payload: {
      data: { ...payload }
    }
  };
}

export function updateEvaluationAuthor(evaluationId, authorId) {
  return dispatch => {
    dispatch(updateEvaluationAuthorRequest());
    return db
      .collection("evaluations")
      .doc(evaluationId)
      .update({
        userId: authorId,
        updateTime: window.firebase.firestore.FieldValue.serverTimestamp()
      })
      .then(function() {
        dispatch(updateEvaluationAuthorSuccess());
      })
      .catch(function(error) {
        dispatch(updateEvaluationAuthorFailed(error));
      });
  };
}

// add peer response

export function updatePeerResponseRequest() {
  return {
    type: EDIT_PEER_RESPONSE,
    payload: {}
  };
}

export function updatePeerResponseSuccess() {
  return {
    type: EDIT_PEER_RESPONSE_SUCCESS,
    payload: {}
  };
}

export function updatePeerResponseFailed(payload) {
  return {
    type: EDIT_PEER_RESPONSE_FAILED,
    payload: {
      data: { ...payload }
    }
  };
}

export function updatePeerResponse(evaluationId, peer, data, name) {
  const peerName = `${peer}Name`;
  return dispatch => {
    dispatch(updatePeerResponseRequest());
    return db
      .collection("evaluations")
      .doc(evaluationId)
      .update({
        [peer]: data,
        [peerName]: name,
        updateTime: window.firebase.firestore.FieldValue.serverTimestamp()
      })
      .then(function() {
        dispatch(updatePeerResponseSuccess());
      })
      .catch(function(error) {
        dispatch(updatePeerResponseFailed(error));
      });
  };
}



// WEBPACK FOOTER //
// ./src/modules/evaluation/actions.js